import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { BILLING_PAYMENT_SCHEDULE_TYPES } from "../../types/billings";
import { ToggleSwitch, ToggleSwitchProps } from "../ToggleSwitch/ToggleSwitch";

type ToggleSwitchBillingPaymentScheduleTypeProps = Omit<ToggleSwitchProps, "options">;

export const ToggleSwitchBillingPaymentScheduleType: React.FC<ToggleSwitchBillingPaymentScheduleTypeProps> = ({
  selectedValue,
  onChange,
  ...rest
}) => {
  const { t } = useTranslation();

  const handleToggle = (value: string) => {
    onChange(value);
  };

  const options = useMemo(
    () =>
      BILLING_PAYMENT_SCHEDULE_TYPES.map((type) => ({
        label: t(`billingPaymentScheduleType.${type}`),
        value: type,
      })),
    [t, BILLING_PAYMENT_SCHEDULE_TYPES]
  );

  return <ToggleSwitch options={options} selectedValue={selectedValue} onChange={handleToggle} {...rest} />;
};
